import LICENSE_STATUS from "@/constants/licenseStatus";
import { format } from "date-fns";
import { useRouter } from "next/router";
import React, { useState } from "react";
import useSub from "./useSub";
import DODO_STATUS_TYPE from "@/constants/dodoStatusType";
import { ROLE } from "@/middleware.constant";
import { getWithExpiry } from "@/utils/helper";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { X } from "lucide-react";
import useUser from "./useUser";
import { isAuth } from "@/network/helper";
import { Button } from "../ui/button";
import { PATHS_FOR_TRIAL_NOTIFICATION } from "./constant";
import { useSelector } from "react-redux";

export default function TrialPeriodBanner() {
  const { userData: user, isUserLoading } = useUser(isAuth());
  const router = useRouter();
  const isTourCompleted = useSelector(s => s.tour.completed);
  const [showTrialWarning, setShowTrialWarning] = useState(() => {
    const val = getWithExpiry("maaranTrialWarningShow");
    return val === null ? true : val;
  });

  // check if i can fetch the subscription
  const isAdministrator =
    user?.attributes?.role_numeric == ROLE.ADMIN ||
    user?.attributes?.role_numeric == ROLE.OWNER;

  const isAllowedToFetchSubscription =
    user?.id &&
    router.pathname != "/organization" &&
    router.pathname != "/on-board";

  const { subscriptionData: subscription, isLoading } = useSub(
    isAllowedToFetchSubscription == true,
  );

  // check if subscription is in trial period
  const isTrial = () => {
    if (subscription?.attributes) {
      return subscription.attributes.dodo_status === DODO_STATUS_TYPE.trial;
    }
    return false;
  };

  // check trial notification is already showed.
  const handleClose = () => {
    localStorage.setItem(
      "maaranTrialWarningShow",
      false,
      2 * 24 * 60 * 60 * 1000,
    );
    setShowTrialWarning(false);
  };

  if (
    !isTrial() ||
    isLoading ||
    !showTrialWarning ||
    !PATHS_FOR_TRIAL_NOTIFICATION.includes(router.pathname) ||
    isUserLoading ||
    !isTourCompleted
  )
    return null;

  return (
    <div className="relative">
      <Alert className="absolute top-6 left-1/2 -translate-x-1/2 w-max rounded-xl flex gap-12 z-50 ">
        <div>
          <AlertTitle className="text-[1.4rem] mb-4">
            Your Trial Ends on &nbsp;
            {format(
              new Date(subscription?.attributes?.trial_ends_at),
              "dd MMM yyyy",
            )}
          </AlertTitle>
          <AlertDescription className="text-[1.4rem] text-foreground/70">
            You are currently on a trial version.
            {isAdministrator
              ? "Please upgrade your plan to continue enjoying our services without interruption."
              : "Contact your admin to upgrade to a subscription plan."}
          </AlertDescription>
        </div>
        <div className="flex items-center gap-4">
          {isAdministrator &&
            user?.attributes?.license_status == LICENSE_STATUS.FULL_ACCESS && (
              <Button
                onClick={() => router.push("/plans")}
                className="p-4 text-[1.4rem] rounded-xl"
                variant="default"
              >
                Upgrade
              </Button>
            )}
          <Button
            variant="ghost"
            onClick={handleClose}
            className=" p-2 rounded-full bg-gray-100 hover:bg-red-500 hover:text-white"
          >
            <X
              className=""
              style={{
                width: 15,
                height: 15,
              }}
            />
          </Button>
        </div>
      </Alert>
    </div>
  );
}
